import { NotificationTypes } from './notification-types';

export interface NotificationModel {
  id: string;
  dateOfNotification: Date;
  type: NotificationTypes;
  title: string;
  highlightBody: string;
  body: string;
  image: string;
  identifier: string;
  isRead: boolean;
}
